import React from 'react';
import Button from '@material-ui/core/Button';
import './SubmitButton.scss';

export const SubmitButton = ({ onClick, text }) => (
    <Button
        className={'submit-button'}
        type={'submit'}
        variant={'contained'}
        disableRipple
        onClick={onClick}
    >
        {text}
    </Button>
);
